import { render, staticRenderFns } from "./BnDocBtn.vue?vue&type=template&id=012e10f6&"
import script from "./BnDocBtn.vue?vue&type=script&lang=js&"
export * from "./BnDocBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports